import { render } from "./BloodPanelSelectedTests.vue?vue&type=template&id=282e710c"
import script from "./BloodPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./BloodPanelSelectedTests.vue?vue&type=script&lang=js"

import "./BloodPanelSelectedTests.vue?vue&type=style&index=0&id=282e710c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sendOuts/testInfo/selectedTestsPreview/BloodPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "282e710c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('282e710c', __exports__)) {
    console.log('reload')
    api.reload('282e710c', __exports__)
  }
  
  module.hot.accept("./BloodPanelSelectedTests.vue?vue&type=template&id=282e710c", () => {
    console.log('re-render')
    api.rerender('282e710c', render)
  })

}


export default __exports__